export const purple = "#1c2437";
export const pink = "#eda3b5";
export const lightgrey = "#E6E5EA";
